let _ = t => t,
  _t;
/* eslint-disable hubspot-dev/prefer-hubspot-url-utils */
import FormattedMessage from 'I18n/components/FormattedMessage';
import { css, mediaQuery, useMediaQuery } from 'academy-common-lib/utils/Styling';
import styled from 'foundations-theming/utils';
import { Button } from 'foundations-components/transitional/components/Button';
import HorizontalLayoutContainer from '../publicLayout/components/HorizontalLayoutContainer';
// @ts-expect-error img
import checkmark from 'bender-url!../../../images/homepage/green-checkmark.svg';
// @ts-expect-error img
import mobileBackground from 'bender-url!../../../images/homepage/corner-blobs.png';
// @ts-expect-error img
import homepageHeroBackground from 'bender-url!../../../images/homepage/white-curved-header.svg';
import PersonaImage from './HeroPersonaImage';
import { getSignupCtaHref } from '../../utils/urls';
import HeroTypingHeading from './HeroTypingHeading';
import { ThemedPrimaryButtonMixin } from '../../components/ThemedComponents';
import styledWithTheme from 'foundations-theming/utils';
import { View } from 'foundations-components/transitional/components/View';
import { Tag } from 'foundations-components/transitional/components/Tag';
import { getMarketingThemePreference } from 'academy-common-lib/features/publicTheme/themeUtils';
import { TFlex } from 'foundations-components/transitional/components/TFlex';

// @ts-expect-error img
import HeroImage from 'bender-url!../../../images/homepage/hero-personas/hero-image-compressed.jpeg';
import { Image } from 'foundations-components/transitional/components/Image';
import { Text } from 'foundations-components/components/Text';
import { Box } from 'foundations-components/transitional/components/Box';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const HeroSection = styledWithTheme.section(_t || (_t = _`
  text-align: center;
  box-shadow: inset 0 6px 6px -6px rgba(33, 51, 67, 0.12);
  background: ${0} url(${0}) bottom;
  background-size: cover;

  ${0}
`), ({
  theme: trellisTheme
}) => trellisTheme.color['do-not-use-gypsum'], homepageHeroBackground, mediaQuery('mobile', css(["background:url(", ") no-repeat bottom right;background-size:80%;"], mobileBackground)));
const HeroContainer = styled.div.withConfig({
  displayName: "HomepageHeroSection__HeroContainer",
  componentId: "sc-16nkxee-0"
})(["position:relative;", ""], mediaQuery('notLaptop', css(["display:grid;grid-template-columns:1fr 2fr 1fr;"])));
const HeroContent = styled.div.withConfig({
  displayName: "HomepageHeroSection__HeroContent",
  componentId: "sc-16nkxee-1"
})(["padding-top:48px;padding-inline:32px;"]);
const HeroDescription = styled.p.withConfig({
  displayName: "HomepageHeroSection__HeroDescription",
  componentId: "sc-16nkxee-2"
})(["font-weight:600;line-height:1.6;", ""], mediaQuery('notMobile', css(["font-size:16px;"])));
const HeroButton = styled.div.withConfig({
  displayName: "HomepageHeroSection__HeroButton",
  componentId: "sc-16nkxee-3"
})(({
  theme: trellisTheme
}) => {
  const {
    isNotMobile
  } = useMediaQuery();
  return Object.assign({
    padding: `${trellisTheme.space['400']} ${trellisTheme.space['800']} !important`
  }, ThemedPrimaryButtonMixin(), isNotMobile && {
    fontSize: '16px'
  });
});
const PersonaBottom = styled.div.withConfig({
  displayName: "HomepageHeroSection__PersonaBottom",
  componentId: "sc-16nkxee-4"
})(["grid-column:1 / -1;padding-bottom:160px;position:relative;", ""], mediaQuery('tablet', css(["padding-bottom:128px;"])));
const HeroBenefits = styled.ul.withConfig({
  displayName: "HomepageHeroSection__HeroBenefits",
  componentId: "sc-16nkxee-5"
})(["list-style:none;font-size:16px;font-weight:600;padding-left:0;width:fit-content;margin:0 auto;", " li{display:inline-block;", "}li::before{content:url(", ");display:inline;line-height:110%;margin-right:8px;vertical-align:middle;}"], mediaQuery('notMobile', css(["display:flex;flex-wrap:wrap;justify-content:center;column-gap:22px;"])), mediaQuery('mobile', css(["font-size:14px;display:flex;margin-bottom:12px;text-align:left;"])), checkmark);
const MarketingHomepageHeroSection = () => {
  const {
    isMobile
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: 'fill-surface-recessed',
    paddingBlock: "1400",
    children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        flexDirection: isMobile ? 'column-reverse' : 'row',
        gap: 48,
        children: [/*#__PURE__*/_jsxs(Box, {
          minInlineSize: "50%",
          children: [/*#__PURE__*/_jsx(Tag, {
            marginBlockEnd: "800",
            children: /*#__PURE__*/_jsxs(List, {
              inline: true,
              use: "inline-divided",
              children: [/*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.homepage.heroSection.benefits1"
                })
              }), /*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.homepage.heroSection.benefits2"
                })
              }), /*#__PURE__*/_jsx(ListItem, {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.homepage.heroSection.benefits3"
                })
              })]
            })
          }), /*#__PURE__*/_jsx(View, {
            inlineSize: "inherit",
            children: /*#__PURE__*/_jsx(HeroTypingHeading, {})
          }), /*#__PURE__*/_jsx(Text, {
            marginBlockEnd: "800",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.homepage.heroSection.description"
            })
          }), /*#__PURE__*/_jsx(Button, {
            href: getSignupCtaHref('academy-home-hero'),
            use: "primary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.homepage.heroSection.ctaText"
            })
          })]
        }), /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(View, {
            borderRadius: "400",
            overflow: "hidden",
            children: /*#__PURE__*/_jsx(Image, {
              alt: "Hero image",
              src: HeroImage
            })
          })
        })]
      })
    })
  });
};
const HomepageHeroSection = () => {
  const isMarketingThemeEnabled = getMarketingThemePreference();
  if (isMarketingThemeEnabled) {
    return /*#__PURE__*/_jsx(MarketingHomepageHeroSection, {});
  }
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(HeroSection, {
      className: "academy-homepage-hero-section",
      children: /*#__PURE__*/_jsx(HorizontalLayoutContainer, {
        size: "large",
        children: /*#__PURE__*/_jsxs(HeroContainer, {
          children: [/*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(PersonaImage, {
              imageNumber: 1
            }), /*#__PURE__*/_jsx(PersonaImage, {
              imageNumber: 2
            })]
          }), /*#__PURE__*/_jsxs(HeroContent, {
            children: [/*#__PURE__*/_jsx(HeroTypingHeading, {}), /*#__PURE__*/_jsx(HeroDescription, {
              className: "m-bottom-6",
              children: /*#__PURE__*/_jsx(FormattedMessage, {
                message: "academyPublic.homepage.heroSection.description"
              })
            }), /*#__PURE__*/_jsx(HeroButton, {
              children: /*#__PURE__*/_jsx(Button, {
                href: getSignupCtaHref('academy-home-hero'),
                use: "primary",
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.homepage.heroSection.ctaText"
                })
              })
            }), /*#__PURE__*/_jsxs(HeroBenefits, {
              className: "m-top-8",
              children: [/*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.homepage.heroSection.benefits1"
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.homepage.heroSection.benefits2"
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(FormattedMessage, {
                  message: "academyPublic.homepage.heroSection.benefits3"
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx(PersonaImage, {
              imageNumber: 3
            }), /*#__PURE__*/_jsx(PersonaImage, {
              imageNumber: 4
            })]
          }), /*#__PURE__*/_jsxs(PersonaBottom, {
            children: [/*#__PURE__*/_jsx(PersonaImage, {
              imageNumber: 5
            }), /*#__PURE__*/_jsx(PersonaImage, {
              imageNumber: 6
            })]
          })]
        })
      })
    })
  );
};
export default HomepageHeroSection;